import styled from '@emotion/styled';
import { TabList } from '@mui/lab';

export const StyledSubTabs = styled(TabList)`
  .MuiTabs-flexContainer {
    justify-content: space-between;
    max-width: 190px;
  }

  .MuiButtonBase-root.MuiTab-root {
    position: absolute !important;
    // background: white;
    border-radius: 5px;
    padding: 6px 16px !important;
    color: #9d9d9d !important;

    min-height: 30px !important;

    :hover {
      background: white !important;
      color: black !important;
    }
  }

  .MuiButtonBase-root.MuiTab-root.Mui-selected {
    position: relative !important;
    z-index: 0 !important;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    word-wrap: brack-word;
    background: #deecf8;
    color: black !important;
    /* main green */
  }
  .MuiButtonBase-root.MuiTab-root {
    text-align: left;
    position: relative !important;
    // padding: 10px;
    width: fit-content !important;
    z-index: 0 !important;
    margin: 0 !important;
    font-family: Public Sans, sans-serif !important;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;

    // :hover {
    //   background-color: pink;
    // }
  }

  .MuiTabs-indicator {
    display: none;
  }
`;

export const StyledSubTabsScheduler = styled(TabList)(({ theme }) => ({
  '.MuiTabs-flexContainer': {
    justifyContent: 'space-between',
    width: 'unset !important',
    backgroundColor: '#f5f4f4',
    borderRadius: 16,
    padding: 8,
    [theme.breakpoints.up('xs')]: {
      // width: '334px !important',
      justifyContent: 'space-between'
    }
  },

  '.MuiButtonBase-root.MuiTab-root': {
    position: 'absolute',
    background: '#f5f4f4',
    borderRadius: 12,
    padding: '6px 16px',
    color: '#9d9d9d',
    minWidth: 100,
    minHeight: 30,
    margin: '0 !important',
    '&:hover': {
      background: 'white',
      color: 'black'
    }
  },

  '.MuiButtonBase-root.MuiTab-root.Mui-selected': {
    position: 'relative',
    zIndex: 0,
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '16px',
    wordWrap: 'break-word',
    background: 'white',
    color: '#0b0b0b',
    fontFamily: 'FixelText-Regular',
    padding: 10,
    borderBottom: 'none',
    margin: '0 !important'
  },

  '.MuiTab-root.Mui-disabled': {
    textAlign: 'left',
    position: 'relative',
    padding: 10,
    width: 'fit-content',
    zIndex: 0,
    margin: '0 !important',
    fontFamily: 'FixelText-Regular',
    color: '#7c7c7c',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '16px'
  },

  '.MuiButtonBase-root.MuiTab-root:not(.Mui-disabled):not(.Mui-selected)': {
    textAlign: 'left',
    position: 'relative',
    padding: 10,
    width: 'fit-content',
    zIndex: 0,
    margin: '0 !important',
    fontFamily: 'FixelText-Regular',
    color: '#7c7c7c',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '16px'
  },

  '.MuiTabs-indicator': {
    display: 'none'
  }
}));
